import { combineEpics } from "redux-most";
import * as steps from "common/steps";
import * as introActions from "./introActions";
import * as submissionActions from "submission/submissionActions";
import {
    getStepFields, isStepCompleted,
} from "common/selectors";
import {
  createSyncLocalStorageEpic,
  createLoadLocalStorageEpic,
  createCompleteStepEpic,
  createAcknowledgeSubmissionEpic,
} from "common/stepEpicCommon";

const syncLocalStorageEpic = createSyncLocalStorageEpic(
  [
    submissionActions.CANCEL_SUBMISSION,
    submissionActions.SUBMIT,
    introActions.COMPLETE_STEP,
    introActions.SUBMITTER_IS_CONTRIBUTOR_CHANGED,
  ],
  {
      completed: isStepCompleted(steps.INTRO),
      fields: getStepFields(steps.INTRO),
  },
  introActions.localStorageSynced,
  steps.INTRO,
);

export default combineEpics([
  createAcknowledgeSubmissionEpic(steps.INTRO),
  createCompleteStepEpic(
    introActions.COMPLETE_STEP,
    steps.INTRO,
  ),
  createLoadLocalStorageEpic(
    steps.INTRO,
    introActions.localStorageLoaded,
  ),
  syncLocalStorageEpic,
]);
